import { inject, Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { BohrpunktNeuComponent } from './detail/bohrpunkt-neu.component';

/**
 * **Das Fenster „Neuer Punkt" — hoechstens eines gleichzeitig.**
 *
 * Bisher ging es jedes Mal auf, wenn das Kommando `addPoint` kam. Kam es
 * zweimal, standen zwei Fenster uebereinander: Man sieht nur das obere, gibt
 * die Nummer ein, legt an — und dahinter steht das naechste, mit derselben
 * Stelle. Wer auch dort auf „Anlegen" drueckt, hat zwei Punkte uebereinander
 * (Nutzer-Befund 04.09.2026).
 *
 * Zweimal kommen kann das Kommando aus mehreren Richtungen: zwei Melder an der
 * Karte, ein Doppeltipp auf dem Tablet, zweimal auf den Standort-Knopf. Statt
 * jede Quelle einzeln abzudichten, gilt hier die Regel selbst — ein Fenster,
 * eine Entscheidung.
 */
@Injectable({ providedIn: 'root' })
export class NeuerPunktFensterService {
	private modalService = inject(NgbModal);

	/** Steht gerade ein Anlege-Fenster offen? */
	private offen = false;

	/**
	 * Oeffnet das Fenster und gibt es zurueck — oder `null`, wenn schon eines
	 * offen steht. `vorbereiten` bekommt das Fenster, um Stelle und Vorlage zu
	 * setzen; das geschieht wie bisher direkt nach dem Oeffnen.
	 */
	oeffne(vorbereiten?: (fenster: BohrpunktNeuComponent) => void): NgbModalRef | null {
		if (this.offen) return null;
		this.offen = true;

		let ref: NgbModalRef;
		try {
			ref = this.modalService.open(BohrpunktNeuComponent);
		} catch (fehler) {
			// Geht das Oeffnen schief, darf die Sperre nicht stehenbleiben —
			// sonst liesse sich nie wieder ein Punkt anlegen.
			this.offen = false;
			throw fehler;
		}

		// `hidden` meldet jedes Ende: angelegt, abgebrochen, oder vom Fenster
		// selbst geschlossen (kein Projekt offen). `complete` als zweite Sicherung.
		ref.hidden.subscribe({
			next: () => { this.offen = false; },
			complete: () => { this.offen = false; },
		});

		vorbereiten?.(ref.componentInstance);
		return ref;
	}
}
